var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',_vm._g(_vm._b({class:{ focused: _vm.isFocused, 'error-input': _vm.hasError },attrs:{"outlined":"","dense":"","flat":"","menu-props":{ bottom: true, offsetY: true }},on:{"focusin":function($event){_vm.isFocused = true},"focusout":function($event){_vm.isFocused = false}},scopedSlots:_vm._u([(_vm.needSelection)?{key:"selection",fn:function(ref){
var attrs = ref.attrs;
var item = ref.item;
var selected = ref.selected;
return [_vm._t("selection",null,{"item":item,"attrs":attrs,"selected":selected})]}}:null,(_vm.needItem)?{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._t("item",null,{"item":item})]}}:null],null,true)},'v-combobox',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }